import type { Feature } from '@luna/gatekeeper';

export const installments: Feature = {
    enabled: true,
    _description: 'Enables display of the installments page for credit cards and current accounts',
};
